import Vue from 'vue';
import Vuebar from 'vuebar';
import VeeValidate from 'vee-validate';

Vue.use(Vuebar);
Vue.use(VeeValidate);

Vue.component('resellers',          require('../components/Reseller.vue').default);
Vue.component('resellers-products', require('../components/ResellerProducts.vue').default);
Vue.component('icesorts',           require('../components/Icesorts.vue').default);
Vue.component('booking',            require('../components/Booking.vue').default);

new Vue({
    el: '#main-content'
});
